/** @format */

import { FormLogin } from "types";
import { END_POINT } from "utils";
import axiosClient from "./axios";

export const authService = {
  login: async (formData: FormLogin) => {
    try {
      const rs = await postRequest(END_POINT.AUTH.LOGIN, formData);
      return rs.data;
    } catch (error) {
      return error
    }
  },
  refreshToken: async () => {
    try {
      const rs = await postRequest(END_POINT.AUTH.REFRESH_TOKEN, {});
      return rs.data;
    } catch (error) {
      console.log("🚀 ~ refreshToken: ~ error:", error)

    }
  },
  me: async () => {
    try {
      const rs = await getRequest(END_POINT.AUTH.ME);
      return rs.data;
    } catch (error) {
      console.log("🚀 ~ me: ~ error:", error)

    }
  },
  logout: async () => {
    try {
      const rs = await postRequest(END_POINT.AUTH.LOGOUT, {});
      return rs.data;
    } catch (error) {
      console.log("🚀 ~ logout: ~ error:", error)

    }
  },
};

const postRequest = (url: string, param: any) => axiosClient.post(url, param);
const getRequest = (url: string) => axiosClient.get(url);
